import { SystemState } from './types'

export const getGuides = (state: SystemState) => state.guides
